export const getArticleCta = (type) => {
  if (!type) {
    return 'Read More';
  }
  let label;
  switch (type.toLowerCase()) {
    case 'whitepaper':
      label = 'Read the Whitepaper';
      break;
    case 'guide':
      label = 'Read the Guide';
      break;
    case 'video':
      label = 'Watch the Video';
      break;
    case 'report':
      label = 'Read the Report';
      break;
    default:
      label = 'Read More';
      break;
  }
  return label;
};

export const isLocalLink = (url) =>
  url && (url.indexOf('fullstory.com') > -1 || url.indexOf('fullstorypreview.com') > -1 || url.indexOf('/') === 0);

export const preventOrphans = (text) => {
  if (!text) return null;
  const lastSpace = text.lastIndexOf(' ');
  const textWithoutOrphans = text.substring(0, lastSpace) + '\u00a0' + text.substring(lastSpace + 1);
  return textWithoutOrphans.replaceAll('-', '\u2011');
};
